var inputs = document.querySelectorAll("form input");
function capitalize(text) {
    return text[0].toUpperCase() + text.slice(1);
}
inputs.forEach(function(input) {
    var label = document.createElement("label");
    var capitalizedName = capitalize(input.name);
    label.classList.add("field-label");
    label.setAttribute("for", input.id);
    label.textContent = capitalizedName;
    input.placeholder = capitalizedName;
    input.parentElement.prepend(label);
});

//# sourceMappingURL=index.cb8e1b55.js.map
